export default {"src":"/_next/static/media/Hamburger.cd10d903.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};